import { Button, ButtonVariant, Size } from "@blueprintjs/core";
import type { ReactNode } from "react";
import { Link, type To } from "react-router-dom";
import styled from "styled-components";
import Guid from "./Guid";

export interface GuidLinkProps {
  children: string;
  buttonText?: ReactNode;
  to: To;
  title?: string;
}

const IdContainer = styled.span`
    white-space: nowrap;
  `;

export function GuidLink({ children, buttonText, to, title }: GuidLinkProps) {
  return (
    <IdContainer>
      <Guid value={children} />
      <Link to={to}>
        <Button
          title={title}
          size={Size.SMALL}
          variant={ButtonVariant.MINIMAL}
          endIcon="arrow-right"
        >
          {buttonText ?? "Open"}
        </Button>
      </Link>
    </IdContainer>
  );
}
